var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85498 15.2619C5.93966 15.5504 6.11549 15.8036 6.35615 15.9838C6.59681 16.164 6.88935 16.2613 7.18998 16.2613C7.49061 16.2613 7.78315 16.164 8.02381 15.9838C8.26447 15.8036 8.4403 15.5504 8.52498 15.2619",
    stroke: "#691634",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55281 3.20444L9.94104 1.75555",
    stroke: "#691634",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55288 3.20446C10.8338 3.54768 11.9259 4.38567 12.5889 5.53409C13.252 6.68251 13.4316 8.04729 13.0884 9.32819C11.8727 13.8655 12.6308 14.8996 12.6308 14.8996L1.03972 11.7938C1.03972 11.7938 2.33625 10.8188 3.42915 6.74C3.77237 5.4591 4.61036 4.36701 5.75878 3.70397C6.90721 3.04093 8.27198 2.86125 9.55288 3.20446V3.20446Z",
    stroke: "#691634",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationType);
export default __webpack_public_path__ + "static/media/notification-type.dd902f0d8470331712b180275406a9af.svg";
export { ForwardRef as ReactComponent };